export default __webpack_public_path__ + "static/media/pin-8x10px-bdbdbd.6b5c176b.svg";